import { render, staticRenderFns } from "./property-list.vue?vue&type=template&id=772ae3f2&scoped=true"
import script from "./property-list.vue?vue&type=script&lang=js"
export * from "./property-list.vue?vue&type=script&lang=js"
import style0 from "./property-list.vue?vue&type=style&index=0&id=772ae3f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772ae3f2",
  null
  
)

export default component.exports